const MAX_INITIALS_TO_SHOW = 3;

export default function initials(name) {
	const names = typeof name === 'string' && name.split(' ') || [];
	const chars = names.map((name) => `${name.charAt(0).toUpperCase()}`);
	return chars.length > 2 ? chars.slice(0, MAX_INITIALS_TO_SHOW).join('') : chars.join('');
}
